import "core-js/modules/es.function.name.js";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useTranslation } from 'react-i18next';
import { Flex, Text } from '@chakra-ui/react';
import { ButtonPrimary, ButtonSecondary, HSpacer, colors, ResponsiveVSpacer, When, LoadingDot } from '@aftersale-next/ui';
import PolicyTerms from '../policy-terms';
import { useChannelSelection } from '../../hooks/use-channel-selection';
import IconContainerRounded from './elements/icon-container-rounded';
export default function ChannelConfirmationContainer(_ref) {
  var name = _ref.name,
      children = _ref.children,
      isDisabled = _ref.isDisabled,
      handleConfirm = _ref.handleConfirm,
      label = _ref.label,
      iconBgColor = _ref.iconBgColor,
      icon = _ref.icon,
      isLoading = _ref.isLoading;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useChannelSelection = useChannelSelection(),
      _useChannelSelection2 = _slicedToArray(_useChannelSelection, 2),
      setSelected = _useChannelSelection2[1];

  var handleCancel = function handleCancel() {
    return setSelected('');
  };

  var onSubmit = function onSubmit(ev) {
    ev.preventDefault();
    handleConfirm();
  };

  return /*#__PURE__*/_jsxs(Flex, {
    w: "100%",
    as: "form",
    onSubmit: onSubmit,
    justify: "flex-start",
    bgColor: colors.appBackground,
    borderRadius: "28px",
    flexDir: "column",
    border: "1px solid ".concat(colors.divider),
    children: [/*#__PURE__*/_jsxs(Flex, {
      h: "56px",
      borderRadius: "30px 30px 0px 0px",
      bgColor: "white",
      p: "2",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(IconContainerRounded, {
        accent: iconBgColor,
        children: icon
      }), /*#__PURE__*/_jsx(Text, {
        color: colors.gray,
        fontSize: "sm",
        fontWeight: "bold",
        children: label
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      p: "4",
      w: "100%",
      flexDir: "column",
      alignItems: "center",
      children: [children, /*#__PURE__*/_jsx(HSpacer, {
        space: "15px"
      }), /*#__PURE__*/_jsx(PolicyTerms, {}), /*#__PURE__*/_jsx(HSpacer, {
        space: "15px"
      }), /*#__PURE__*/_jsxs(Flex, {
        direction: ['column', 'row-reverse'],
        w: "100%",
        minW: {
          md: '400px'
        },
        children: [/*#__PURE__*/_jsxs(ButtonPrimary, {
          id: "trakr-".concat(name, "-confirm-btn"),
          bgColor: colors.green,
          onClick: handleConfirm,
          disabled: isDisabled || isLoading,
          children: [/*#__PURE__*/_jsx(When, {
            value: !isLoading,
            children: t('CONFIRM')
          }), /*#__PURE__*/_jsx(When, {
            value: isLoading,
            children: /*#__PURE__*/_jsx(LoadingDot, {})
          })]
        }), /*#__PURE__*/_jsx(ResponsiveVSpacer, {
          defaultSpace: "16px",
          mobileSpace: "0"
        }), /*#__PURE__*/_jsx(ButtonSecondary, {
          id: "trakr-".concat(name, "-confirm-btn"),
          onClick: handleCancel,
          bgColor: "transparent",
          textColor: colors.textForeground,
          borderColor: colors.textForeground,
          minWidth: "30px",
          children: t('BACK')
        })]
      }), /*#__PURE__*/_jsx(HSpacer, {
        space: "15px"
      })]
    })]
  });
}